
import { CF } from "../../_common/layout";
import { TechnicalRequirements } from "./technical-requirements";
import { h } from "preact";
import { t } from '../../_i18n';


export const Terms = ({content}) =>
    <CF className="sm-card max-width-sm">
        <div className={"sm-p-x2-top sm-p-x2-bottom sm-p-left sm-p-right t-justify"}>
            <div dangerouslySetInnerHTML={{__html: content}} />
            <div className="p-x2-top" />
            <TechnicalRequirements />
        </div>
    </CF>;  
